<template>
  <div class="delivery_mode " :class="{botto_border: !isLastItem}">
    <div class="font_regular text_16 font_600 word_break">{{item.title}}</div>
    <div class="price_time">
        <div class="font_regular text_12 font_600 text_black_secondary word_break">{{item.time}}</div>
        <div class="font_regular text_14 font_500">
            {{ merchant.paid_by_customer ? item.amount : 0}}
            {{item.currency}}
        </div>
    </div>
    <div class="radio_btn_container">
        <label class="radio_wrap" for="">
            <input
                type="radio"
                :value="item.id"
                :checked="selectedMode === item.id"
                @change="handleChange(item)"
            />
        </label>
    </div>
  </div>
</template>

<script>

export default {
    components: {

    },
    props:{
        item:{
            default: {}
        },
        selectedMode:{
            default: null
        },
        handleChange:{
            type: Function
        },
        isLastItem:{
            type: Boolean,
            default: false
        },
        merchant:{
            type: Object,
            default: {},
        },
    },
    data(){
        return {

        }
    },
    methods:{

    },
}
</script>


<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_fonts.scss';

.delivery_mode{
    display: grid;
    grid-template-columns: 180px 1fr 20px;
    gap: 4px;
    padding: 8px 0;
    .price_time{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 4px;
    }
}
.botto_border{
    border-bottom: 1px solid #EEEEEE;
}

.radio_wrap{
    height: 23px;
}
.radio_wrap input {
    appearance: none;
    width: 18px;
    height: 18px;
    border: 2px solid var(--w-500);
    border-radius: 50%;
    outline: none;
    cursor: pointer;
    position: relative;
    margin: 0;
}

.radio_wrap input:checked {
  background-color: white;
}


.radio_wrap input:checked::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  // background: var(--w-500);
  background: #8D25F6;
  transform: translate(-50%, -50%);
}


.radio_btn_container{
    display: flex;
    align-items: center;
}
</style>